export default __webpack_public_path__ + "static/logo-georges-734f7207dcbc5e5c8100291d5d943ca8.png";